"use client";

import { motion } from "framer-motion";
import { getViewModeChrome } from "../view-mode-chrome";

export function TickerSearchLoading({ viewMode }: { viewMode?: string } = {}) {
  const chrome = getViewModeChrome(viewMode);
  return (
    <motion.div
      initial={{ opacity: 0, y: 5 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      className="w-full"
    >
      <div className={`rounded-md border ${chrome.card} overflow-hidden`}>
        {/* Progress bar */}
        <div className="absolute top-0 left-0 h-[1px] w-full">
          <motion.div
            className="h-full bg-gradient-to-r from-foreground/0 via-foreground/60 to-foreground/0"
            initial={{ width: "0%" }}
            animate={{ width: "100%" }}
            transition={{ duration: 4, ease: "linear" }}
          />
        </div>

        <div className="px-3 py-2 flex items-center gap-2.5">
          {/* Radar icon */}
          <div className="relative w-7 h-7 flex items-center justify-center shrink-0">
            {/* Outer ping rings */}
            <motion.span
              className="absolute inset-0 rounded-full border border-foreground/20"
              animate={{ scale: [1, 1.9], opacity: [0.5, 0] }}
              transition={{ duration: 1.6, repeat: Infinity, ease: "easeOut" }}
            />
            <motion.span
              className="absolute inset-0 rounded-full border border-foreground/15"
              animate={{ scale: [1, 1.9], opacity: [0.4, 0] }}
              transition={{ duration: 1.6, repeat: Infinity, ease: "easeOut", delay: 0.5 }}
            />
            {/* Inner circle */}
            <div className="w-7 h-7 rounded bg-muted/50 flex items-center justify-center relative z-10">
              {/* Radar sweep dot */}
              <motion.div
                className="absolute w-1 h-1 rounded-full bg-foreground/70"
                style={{ transformOrigin: "50% 50%" }}
                animate={{ rotate: 360 }}
                transition={{ duration: 1.8, repeat: Infinity, ease: "linear" }}
                // offset dot from center to create sweep look
              >
                <span className="block w-1 h-1 rounded-full bg-foreground/80 -translate-y-[9px]" />
              </motion.div>
              {/* Center dot */}
              <span className="w-1.5 h-1.5 rounded-full bg-foreground/40 z-10" />
            </div>
          </div>

          <span className={`text-[13px] font-semibold ${chrome.text} truncate`}>Scanning the markets...</span>
        </div>
      </div>
    </motion.div>
  );
}
